import { render, staticRenderFns } from "./OrderPreparation.vue?vue&type=template&id=674a10b1&scoped=true&"
import script from "./OrderPreparation.vue?vue&type=script&lang=ts&"
export * from "./OrderPreparation.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPreparation.vue?vue&type=style&index=0&id=674a10b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a10b1",
  null
  
)

export default component.exports